import { useRoleAccessContext } from "../context/roleAccessContext";

export const useCanAccessRoute = () => {
  const { accessSections } = useRoleAccessContext();

  const canAccessRoute = (key: string) => {
    return accessSections?.includes(key);
  };

  return { canAccessRoute };
};
